module.exports = {
        srcSet: __webpack_public_path__ + "static/media/coin-664.55b353c9.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/coin-664.55b353c9.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/coin-664.55b353c9.webp",
        toString: function(){return __webpack_public_path__ + "static/media/coin-664.55b353c9.webp"},
        
        width: 664,
        height: 664
      }